import { render, staticRenderFns } from "./knowledgeList.vue?vue&type=template&id=116469c4&scoped=true&"
import script from "./knowledgeList.vue?vue&type=script&lang=js&"
export * from "./knowledgeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116469c4",
  null
  
)

export default component.exports